import { render, staticRenderFns } from "./UsedFeatureShortMessage.vue?vue&type=template&id=3b4616c4"
import script from "./UsedFeatureShortMessage.vue?vue&type=script&lang=js"
export * from "./UsedFeatureShortMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports